import { Check, Circle } from 'lucide-react'

import { passwordRules } from '@/lib/password'
import { cn } from '@/lib/cn'

/** Lista wymagań hasła aktualizowana na bieżąco podczas pisania. */
export function PasswordRules({ password }: { password: string }) {
  const rules = passwordRules(password)

  return (
    <ul className="grid gap-1.5 sm:grid-cols-2" aria-label="Wymagania dotyczące hasła">
      {rules.map((rule) => (
        <li
          key={rule.label}
          className={cn(
            'flex items-center gap-2 text-xs font-semibold transition-colors',
            rule.isMet ? 'text-success' : 'text-on-surface-variant',
          )}
        >
          <span aria-hidden="true">{rule.isMet ? <Check size={14} /> : <Circle size={14} />}</span>
          {rule.label}
          <span className="sr-only">{rule.isMet ? ' — spełnione' : ' — niespełnione'}</span>
        </li>
      ))}
    </ul>
  )
}
